/* global RdcTracking */

export const trackShare = function(omtag, successShare=false, propListingId=false) {
  const articlePageUrl = window.location.href;
  const pageType = MOVE_DATA.adobeDTM.pageType;
  const listingId = MOVE_DATA.adobeDTM.listingID || propListingId;
  const eventName = (omtag ? 'socialShare' : 'emailShare');
  let shareName;

  if (MOVE_DATA.ab_share_srp_experiment) { // LGWEB-718
    // LGWEB-718 - start
    const propertyStatus = MOVE_DATA.adobeDTM.propertyStatus;
    const shareType      = omtag || 'email';
    shareName = `${propertyStatus}:${pageType}:card:share_${shareType}`;
    // LGWEB-718 - end
  } else {
    shareName = (successShare ? 'web:share:email:success' : (omtag ? `web:${pageType}:shares:social:${omtag}` : 'web:shares:social:eml'));
  }

  const props = {
    articlePageUrl,
    pageType,
    listingId,
    socialShare: shareName
  };
  if (omtag || successShare) {
    Object.assign(props, {linkName: shareName});
  }
  RdcTracking.trackEvent(eventName, props);
};

export const trackshareEmailButtonClick = function () {
  const eventName = 'click';
  const linkName = 'eml';
  RdcTracking.trackEvent(eventName, {linkName: linkName});
};


// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/shares.js